import React, {Component} from 'react'
import { StaticQuery, graphql } from 'gatsby'

import AgentPropertyCard from './cards/agent-property'

class CurrentAgentListings extends Component {

  state = {
    limit: 6,
  }

  render() {

    let { data, type, agents } = this.props
    let { limit } = this.state
    let { residential, lease, commercial, commercialLease } = data
    let items = []

    if (type === 'residential') {
      items = residential.edges.map(({ node }) => node)
    }
    if (type === 'lease') {
      items = lease.edges.map(({ node }) => node)
    }
    if (type === 'commercial') {
      items = commercial.edges.map(({ node }) => node)
      items = items.concat(commercialLease.edges.map(({ node }) => node))
    }
    // filter properties by agents (can be an array)
    if (agents) {
      items = items.filter(el => {
        let agentsArray = el.propertyStaff.map(agent => agent.staffMemberId)
        // agents array is an array of objects (agents[0].teamDetails.id)
        return agents.some(agent => agentsArray.includes(agent.teamDetails.id));
      })
    }
    // sort by onMarketDate
    items.sort((a, b) => new Date(b.propertyListing.onMarketDate) - new Date(a.propertyListing.onMarketDate))

    return (
      <section className={`agent-properties agent-properties--margin-bottom`}>
        <div className='agent-properties__inner'>
          <h3 className='agent-properties__title'>Current Listings</h3>
          <div className='agent-properties__items'>
            {items?.length > 0 &&
              <>
                {items.slice(0, limit).map((el, i) => {
                  return (<AgentPropertyCard {...el} postType={el.propertyListing.type === 'Sale' ? 'property' : 'rental'} key={i} />)
                })}
              </>
            }
          </div>
          {limit < items?.length &&
            <button className='agent-properties__more' onClick={() => this.setState({limit: limit + 6})}>View More Properties</button>
          }
        </div>
      </section>
    )
  }
}

export default function CurrentAgentListingsQuery(props) {
  return (
    <StaticQuery
      query={graphql`
      query CurrentAgentListingsQuery {
        residential: allWpProperty(
          filter: {propertyData: {type: {eq: "Residential"}}, propertyListing: {status: {eq: "Available"}, hiddenListing: {eq: false}, offMarketListing:
      {eq: false}}}
        ) {
          edges {
            node {
              databaseId
              id
              slug
              title
              propertyAddress {
                hideAddress
                streetAddress
                suburb
                state
                postcode
              }
              propertyData {
                bathrooms
                bedrooms
                type
                carPorts
                carSpaces
                garages
                totalParking
                category
              }
              propertyImages {
                url
                small
                large
              }
              propertyStaff {
                staffMemberId
              }
              propertyListing {
                searchPrice
                marketingStatus
                displayPrice
                type
              }
            }
          }
        }
        lease: allWpRental(
          filter: {propertyData: {type: {eq: "Residential"}}, propertyListing: {status: {eq: "Available"}, hiddenListing: {eq: false}, offMarketListing:
      {eq: false}}}
        ) {
          edges {
            node {
              databaseId
              id
              slug
              title
              propertyAddress {
                hideAddress
                streetAddress
                suburb
                state
                postcode
              }
              propertyStaff {
                staffMemberId
              }
              propertyData {
                bathrooms
                bedrooms
                type
                carPorts
                carSpaces
                garages
                totalParking
                category
              }
              propertyImages {
                url
                small
                large
              }
              propertyListing {
                searchPrice
                marketingStatus
                displayPrice
                type
              }
            }
          }
        }
        commercial: allWpProperty(
          filter: {propertyData: {type: {eq: "Commercial"}}, propertyListing: {status: {eq: "Available"}, hiddenListing: {eq: false}, offMarketListing:
      {eq: false}}}
        ) {
          edges {
            node {
              databaseId
              id
              slug
              title
              propertyAddress {
                hideAddress
                streetAddress
                suburb
                state
                postcode
              }
              propertyStaff {
                staffMemberId
              }
              propertyData {
                bathrooms
                bedrooms
                type
                carPorts
                carSpaces
                garages
                totalParking
                category
              }
              propertyImages {
                url
                small
                large
              }
              propertyListing {
                searchPrice
                marketingStatus
                displayPrice
                type
              }
            }
          }
        }
        commercialLease: allWpRental(
          filter: {propertyData: {type: {eq: "Commercial"}}, propertyListing: {status: {eq: "Available"}, hiddenListing: {eq: false}, offMarketListing:
      {eq: false}}}
        ) {
          edges {
            node {
              databaseId
              id
              slug
              title
              propertyAddress {
                hideAddress
                streetAddress
                suburb
                state
                postcode
              }
              propertyData {
                bathrooms
                bedrooms
                type
                carPorts
                carSpaces
                garages
                totalParking
                category
              }
              propertyStaff {
                staffMemberId
              }
              propertyImages {
                url
                small
                large
              }
              propertyListing {
                searchPrice
                marketingStatus
                displayPrice
                type
              }
            }
          }
        }
      }
      `}
      render={data => (
        <CurrentAgentListings data={data} {...props} />
      )}
    />
  )
}